var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddUser = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "add-user",
    d: "M10.214,4.5a4,4,0,0,0-2.232,7.322A5.727,5.727,0,0,0,4.5,17.071H5.643A4.563,4.563,0,0,1,10.214,12.5a4.5,4.5,0,0,1,2.16.554,4.635,4.635,0,1,0,.876-.823,5.8,5.8,0,0,0-.8-.41A4,4,0,0,0,10.214,4.5Zm0,1.143A2.857,2.857,0,1,1,7.357,8.5,2.848,2.848,0,0,1,10.214,5.643ZM15.929,12.5A3.429,3.429,0,1,1,12.5,15.929,3.419,3.419,0,0,1,15.929,12.5Zm-.571,1.143v1.714H13.643V16.5h1.714v1.714H16.5V16.5h1.714V15.357H16.5V13.643Z",
    transform: "translate(-4.5 -4.5)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddUser);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_user.b180f57f029b3247547ff458a6713399.svg";